import PropTypes from "prop-types";


import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../../ui";
import { SupplierCategoryFormDialog } from "../supplier-category-form-dialog";

import { Button } from "@mui/material";

export const AddSupplierCategoryFormDialog = ({ onClose, onSubmitted }) => {
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async ({ name, status }) => {
    try {
      await apiClient.post("supplier-categories", {
        name,
        status,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal menambahkan kategori pemasok"));

      throw error;
    }
  };

  return (
    <SupplierCategoryFormDialog
      dialogTitle="Tambah Kategori Pemasok"
      onClose={onClose}
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Tambah
        </Button>
      )}
    />
  );
};

AddSupplierCategoryFormDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
};
